import { Navigate } from "react-router-dom";
import { isSessionExpired, expireSession } from "../utils/axiosconfig";

export const OpenRoutes = ({ children }) => {
  const storedUser = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user"))
    : null;

  const hasToken = !!storedUser?.token;
  const userRole = String(storedUser?.role || "").toLowerCase();

  if (!hasToken) {
    return children;
  }

  if (isSessionExpired()) {
    expireSession();
    return children;
  }

  if (!userRole) {
    localStorage.removeItem("user");
    localStorage.removeItem("sessionExpiry");
    localStorage.removeItem("sessionExpiredMessage");
    return children;
  }

  return (
    <Navigate
      to={userRole === "employee" ? "/admin/my-leads" : "/admin/dashboard"}
      replace
    />
  );
};